/* eslint-disable prettier/prettier */
/** DO NOT EDIT - This file is auto-generated by running `yarn workspace lib-shared-feature-flags update` */
const defaultFeatureFlags = {
    "a-c-forward": false,
    "ada-chat-channel": false,
    "agent-copilot": false,
    "agent-copilot-auto-translate": false,
    "agent-copilot-pin-actions": true,
    "agent-copilot-trial-eligibility": false,
    "agent-offering-with-business-hours": true,
    "agnostic-csat-settings": true,
    "allow-integration-api-token-usage": false,
    "allow-same-origin-in-sandboxed-custom-card-iframe": false,
    "analytics-custom-dashboards": false,
    "audit-log": true,
    "authorization-custom-role": false,
    "automation-ai-agent-single-interaction-action": false,
    "automation-ai-chatbot-action": true,
    "automation-automation-ai-agent": false,
    "automation-cel-expression": false,
    "automation-flow-sms-channel": true,
    "automation-flow-voice-channel": true,
    "automation-flow-whats-app-channel": true,
    "automation-set-custom-attributes": true,
    "automation-trigger-on-conversation-created": true,
    "automation-trigger-on-custom-attribute": true,
    "automation-trigger-on-tag-untag": true,
    "automations": false,
    "automations-oauth": true,
    "call-noise-suppression": false,
    "chatbot-quota-page": false,
    "chatbots-integration-settings": false,
    "collapse-tracking-card-core": false,
    "contact-memories-conversation-view": false,
    "conversation-assistant-for-dixa-messenger": false,
    "conversation-note-mentions": true,
    "conversation-resolution-state": false,
    "conversation-right-sidebar-visibility": false,
    "conversation-value-metric": false,
    "csat-for-dixa-messenger": false,
    "csat-for-email": false,
    "csat-for-widget-chat": false,
    "custom-analytics": true,
    "custom-attributes-in-compose-email": true,
    "custom-attributes-suggestions": false,
    "custom-away-status": false,
    "custom-form-validation": true,
    "dashboard-aggregate-favorites": true,
    "desktop-app-notice-modal": true,
    "dev-api-authorization-scopes": false,
    "digitalgenius-chat-channel": false,
    "dixa-rewind": false,
    "elevio-suggestions": false,
    "email-channel": true,
    "email-compose-v2": true,
    "email-templates-customization": false,
    "email-translation": true,
    "enable-call-recordings": true,
    "enable-restricted-queues": false,
    "ewt-hide-strategy": false,
    "export-conversations": false,
    "facebook-messenger-channel": true,
    "generic-api-messaging-channel": true,
    "has-bulk-operations": false,
    "has-chat-with-dixa-support": true,
    "has-custom-form-tel-email-fields": false,
    "has-custom-forms-feature": true,
    "has-custom-forms-styling": true,
    "has-messenger": true,
    "inbound-webhooks": true,
    "instagram-management": true,
    "integrations-for-dixa-messenger": false,
    "integrations-for-email": true,
    "integrations-for-phone": true,
    "intent-detection": false,
    "intent-detection-character-limit": 300,
    "kindly-chat-channel": false,
    "knowledge-access": true,
    "knowledge-article-versioning": true,
    "knowledge-articles-ai-auto-translations": false,
    "knowledge-management-nav": false,
    "knowledge-suggestions": true,
    "legacy-presence-sidebar": true,
    "legacy-team-overview": false,
    "message-auto-redaction": false,
    "messenger-form-only-mode-feature": false,
    "mim-automation-variant": false,
    "mim-chatbot": false,
    "mim-conversation-data-source": false,
    "mim-drafts": false,
    "mim-email": false,
    "mim-integration-tools-shopify": true,
    "mim-one-settings-page": false,
    "mim-sidekick": false,
    "mim-web-kb-max-links-access": false,
    "new-whatsapp-onboarding": false,
    "offers-in-chat-conversations": true,
    "organizations-sidebar": false,
    "partner-integrations-datasync": true,
    "partner-integrations-sidebar-conditions": false,
    "phone-channel": true,
    "presence-sidebar-show-self": true,
    "redact-messages": false,
    "reply-all-toggle-and-config": true,
    "routing-audit-log-automations": false,
    "routing-use-canvas": true,
    "scheduled-conversations": false,
    "shadow-dom-messages": true,
    "shopify-marketplace-app": false,
    "show-tracking-card": true,
    "show-twilio-warn-notifications": false,
    "sidebar-cards-admin-management": false,
    "smart-article-create": false,
    "smart-article-create-multi-conversation": false,
    "smart-reply-new-api": false,
    "sms-channel": false,
    "sms-compose": false,
    "spam-filtering": false,
    "subflows-in-dixa-messenger-flow-builder": true,
    "survey-advanced-customization": false,
    "tag-suggestions-enabled": false,
    "teams-assigning-teams-to-queues": true,
    "teams-setting-page-and-assigning-teams-to-queues": true,
    "telephony-numbers-data-residency-regions": false,
    "templates-language-translation-control": false,
    "top-bar-search-quick-actions": true,
    "translate-html": true,
    "translation-hide-original-language": true,
    "trustpilot-channel": true,
    "twitter-channel": false,
    "use-birdeatsbug": false,
    "use-cleaned-up-telephony-middleware": false,
    "use-enable-ios-and-android": false,
    "use-shared-worker": true,
    "use-twilio-voice-sdk": true,
    "voice-ai-agent-action": false,
    "warm-transfer-to-queue": false,
    "website-data-source": false,
    "whatsapp-channel": true,
    "widget-chat-channel": false,
    "write-html-email": true,
    "yotpo-channel": false
};

export { defaultFeatureFlags as default, defaultFeatureFlags };
//# sourceMappingURL=featureFlags.es.js.map
